import { get } from 'lodash';

const getIsLoading = (state: any) => state.isLoading;

export const getIsEntityLoading = (state: any, entity: any, id = '') =>
  Boolean(id ? get(getIsLoading(state), [entity, id]) : getIsLoading(state)[entity]);

export const getIsCategoryLoading = (state: any, id: any) =>
  getIsEntityLoading(state, 'category', id);
export const getIsTagLoading = (state: any, id: any) => getIsEntityLoading(state, 'tag', id);
export const getIsFeedPostsLoading = (state: any) => getIsEntityLoading(state, 'feed-posts');
export const getIsSearchLoading = (state: any) => getIsEntityLoading(state, 'search');
export const getIsArchiveLoading = (state: any) => getIsEntityLoading(state, 'archive');
export const getIsHashtagPostsLoading = (state: any) => getIsEntityLoading(state, 'hashtag-posts');
